<template>
  <div class="terminal" v-loading.lock="isLoading">
    <!-- start: panel -->
    <div class="panel" v-height="pageSize.panel">
      <div class="panel-module">
        <el-button
          plain
          size="mini"
          icon="el-icon-circle-plus-outline"
          @click="onTriggerExecute">执行</el-button>
      </div>
      <div class="panel-module">
        <span style="font-size: 13px;">数据库</span>
        <pi-select
          style="margin-left: 6px"
          size="mini"
          v-model="currentDatabase"
          :options="databaseOptions"
        ></pi-select>
        <!--type="success"-->
        <el-button
          :loading="isRefreshingDatabaseOptions"
          size="mini"
          style="margin-left: 3px;"
          icon="el-icon-refresh"
          @click="getDatabaseOptions"
        ></el-button>
      </div>
    </div>
    <!-- end: panel -->
    <drag-line :calcOutputAreaHeight="calcResultAreaHeight" :pageSize="pageSize">
      <!-- start: editor -->
      <div class="editor" v-height="pageSize.command" slot="line-top">
        <pi-monaco-editor
          ref="piEditor"
          language="sql"
          theme="vs"
          width="100%"
          height="100%"
          v-model="editor.content"
          :options="editor.options"
        ></pi-monaco-editor>
        <!--<el-input
          rows="10"
          type="textarea">
        </el-input>-->
      </div>
      <!-- end: editor -->

      <!-- start: result -->
      <el-tabs
        class="result result_of_mongodb_terminal"
        v-model="activeTab"
        v-height="calcResultAreaHeight"
        slot="line-bottom"
        @tab-remove="handleTabRemove"
      >
        <el-tab-pane :closable="false" class="result-messages" label="消息" name="message">
          <p v-if="resultMessages.length === 0" style="font-size: 14px; color: #444;">暂无消息</p>
          <terminal-message
            v-else
            v-for="(message, index) in resultMessages"
            :key="index"
            :index="index + 1"
            :command="message.command"
            :success="message.success"
            :errMsg="message.errMsg"
            :expand="message.expand"
            :canShow="message.canShow"
          >
          </terminal-message>
        </el-tab-pane>
        <el-tab-pane
          closable
          v-for="pane in resultPanes"
          :key="pane.name"
          :label="pane.title"
          :name="pane.name"
        >
          <terminal-result-pane
            :command="pane.command"
            :result="pane.result"
          ></terminal-result-pane>
        </el-tab-pane>
      </el-tabs>
      <!-- end: result -->
    </drag-line>
  </div>
</template>

<script>
/**
 * @TODO: 编写适用于 mongodb 语言的高亮规则
 * https://microsoft.github.io/monaco-editor/playground.html#extending-language-services-custom-languages
 */

import { reqFetchDatabases, reqExecuteCommand } from '@/api/mongodb';
import { defaultOptions } from '@/config/monaco-editor';
import { buildSelectorOptions } from '@/utils/helpers';
import TerminalResultPane from './TerminalResultPane';
import TerminalMessage from './TerminalMessage';
import PiEditorResize from '@/mixins/PiEditorResize';
import { removeSpace } from '@/utils/helpers';
import Store from '@/store/index';
import DragLine from '@/views/common/DragLine'

export default {
  name: 'Terminal',

  components: {
    TerminalResultPane,
    TerminalMessage,
    DragLine
  },

  mixins: [PiEditorResize],

  data() {
    return {
      isLoading: false,
      isRefreshingDatabaseOptions: false,
      databaseOptions: [],
      currentDatabase: '',
      // 编辑器
      editor: {
        content: '',
        options: defaultOptions
      },
      activeTab: 'message',
      resultMessages: [],
      resultPanes: [],
      lastDatabaseName: '',
      lastCollectionName: '',
      lastTimestamp: 0,
      pageSize: {
        command: 200,
        panel: 42
      },
      notice: {}
    };
  },

  computed: {
    calcResultAreaHeight() {
      // 有 1px 的边框高度,减去拖拽线的高度
      return this.$store.state.size.heightHomeContent - this.pageSize.panel -
        this.pageSize.command - 4;
    }
  },

  watch: {
    $route: {
      handler(to) {
        if(Object.keys(this.notice).length > 0) {
          this.notice.close();
        }
      }
    },
  },

  async created() {
    await this.getDatabaseOptions();
    if (this.databaseOptions.length > 0) {
      this.currentDatabase = this.databaseOptions[0].value;
    }
  },

  methods: {
    async getDatabaseOptions() {
      this.isRefreshingDatabaseOptions = true;
      const res = await reqFetchDatabases();
      let data = res.data.data.map((item)=>{
        return item.DbName
      })
      this.databaseOptions = buildSelectorOptions(data, true);
      this.isRefreshingDatabaseOptions = false;
    },
    onTriggerExecute() {
      this.onExecute(this.editor.content);
    },
    /**
     * 执行命令
     * @param command
     * @returns {Promise<void>}
     */
    async onExecute(command) {
      try {
        if (!this.currentDatabase) {
          this.$message.warning('请先选择一个数据库');
          return;
        }
        if (!this.editor.content) {
          this.$message.warning('命令不能为空');
          return;
        }

        if(Object.keys(this.notice).length > 0) {
          this.notice.close();
        }
        this.isLoading = true;

        const res = await reqExecuteCommand({
          ConnToken: Store.getters['source/connToken'],
          Command: command,
          DataBase: this.currentDatabase
        });
        this.resultPanes = [];

        if(res.data.code.indexOf('len') > -1){
          this.notice = this.$notify({
            title: '提示',
            message: "当前执行SQL语句过长，执行失败",
            type: 'warning',
            duration: 30000
          })
        } else if(res.data.data.Expand) {
          this.notice = this.$notify({
            title: '提示',
            message: "连接超时，命令将在后台执行",
            type: 'warning',
            duration: 30000
          });
          this.resultMessages.push({
            command: command,
            success: false,
            canShow : false
          });
        } else {
        res.data.data = res.data.data.map((item, index) => {
          this.resultMessages.push({
            command: item.cmd,
            success: !item.error,
            errMsg: item.error ? item.error : '',
            expand: item.expand,
            canShow : true
          });
          let obj = {
            title: `结果(${index + 1})`,
            name: ( index + 1) + '',
            command: item.cmd,
            result: item.result,
            type: item.type
          };
          this.resultPanes.push(obj);
        });
        if (this.resultPanes.length > 0)
        {
          this.activeTab = this.resultPanes.length + ''
        }
        }

      } catch (e) {
        this.resultMessages.push({
          command: command,
          success: false,
          canShow : true
        });
        this.resultPanes = [];
      } finally {
        this.isLoading = false;
      }
    },
    handleTabRemove(tabName) {
      let tabs = this.resultPanes;
      let activeName = this.activeTab;
      if (activeName === tabName) {
        tabs.forEach((tab, index) => {
          if (tab.name === tabName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            } else {
              activeName = 'message';
            }
          }
        });
      }

      this.activeTab = activeName;
      this.resultPanes = tabs.filter(tab => tab.name !== tabName);
    }
  }
};
</script>

<style scoped lang="scss">
.terminal {
  height: 100%;
  overflow: hidden;

  .panel {
    height: 44px;
    display: flex;
    align-items: center;

    &-module {
      margin-left: 12px;
      display: flex;
      align-items: center;
    }
  }

  .editor {
    flex: 1;
    border-top: 1px solid #eee;
    background-color: white;
  }

  .result {
    &-messages {
      overflow: auto;
      padding: 8px;
    }
  }
}
</style>

<style lang="scss">
$bgc-tab-header: #e6e8ec;

.result_of_mongodb_terminal {
  height: 100%;
  display: flex;
  flex-direction: column;

  & > .el-tabs__header {
    margin-bottom: 0;
    height: 41px;

    & > .el-tabs__nav-wrap {
      background-color: $bgc-tab-header;
      padding-left: 12px;
      padding-right: 12px;
    }
  }

  & > .el-tabs__content {
    height: 100%;

    & > .el-tab-pane {
      height: 100%;
    }
  }
}
</style>
